
// TypeScript declaration for Crisp
declare global {
  interface Window {
    Crisp?: {
      chat: {
        open: () => void;
      };
    };
  }
}

import { Component, Vue } from 'vue-property-decorator';
import { FEATURES } from '@/config/featureConfig';

@Component
export default class PermissionDenied extends Vue {
  get featureCode(): string {
    return this.$route.query.feature as string || '';
  }

  get redirectUrl(): string {
    return this.$route.query.redirect as string || '/';
  }

  get featureName(): string {
    // Map feature codes to readable names
    const featureMap: {[key: string]: string} = {
      [FEATURES.REPLENISHMENT_CENTER]: 'Replenishment Center',
      [FEATURES.SUPPLIER_MANAGEMENT]: 'Supplier Management',
      [FEATURES.PURCHASE_ORDERS]: 'Purchase Orders',
      [FEATURES.REPORT_ADVANCED_ANALYTICS]: 'Advanced Analytics',
      [FEATURES.REPORT_FULL_EXPORT]: 'Full Report Export',
      [FEATURES.AI_ML_DEMAND_FORECASTING]: 'AI Demand Forecasting',
      [FEATURES.BUYING_TABLE]: 'Advanced Buying Table',
      [FEATURES.BUYING_CALENDAR]: 'Buying Calendar',
      [FEATURES.REPLENISH_FROM_WAREHOUSE]: 'Warehouse Replenishment',
      [FEATURES.ADVANCED_SPREADSHEET_INTEGRATION]: 'Advanced Spreadsheet Integration',
      [FEATURES.QUICKBOOKS_INTEGRATION]: 'QuickBooks Integration',
      [FEATURES.SHOPIFY_FLOW_INTEGRATION]: 'Shopify Flow Integration',
    };

    return featureMap[this.featureCode] || this.formatFeatureCode(this.featureCode);
  }

  get isShopifyFlowFeature(): boolean {
    return this.featureCode === FEATURES.SHOPIFY_FLOW_INTEGRATION;
  }

  formatFeatureCode(code: string): string {
    if (!code) return 'This feature';
    
    // Convert snake_case to Title Case
    return code
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  goBack(): void {
    if (this.$route.query.redirect) {
      this.$router.go(-1);
    } else {
      this.$router.push('/');
    }
  }
  
  openSupport(): void {
    // Open support chat or redirect to support page
    if (window.Crisp) {
      window.Crisp.chat.open();
    } else {
      window.open('mailto:support@assisty.ai', '_blank');
    }
  }
}
